import * as React from "react";
import { Button } from "../button";
import { Icon } from "../icon";

/**
 * The per-page search affordance for the scoped-search model
 * (docs/design/UI-UX-PATTERNS-PRD.md Issue 19, generalizing
 * docs/personal/SCOPED-SEARCH-PRD.md).
 *
 * Content pages no longer render their own `<SearchInput>` bar. Instead the
 * PageHeader toolbar carries this magnifying-glass button, which focuses the
 * root dock search (`open-search` — the same event the top-nav Search button
 * and ⌘K fire). The dock auto-scopes to the page you're on via its path→scope
 * map, so opening it here searches *this page* first; the page mirrors the
 * dock's query from the URL `?q=` and filters its own rows.
 *
 * One affordance, wired app-wide — adding a page to the model is a `SCOPES`
 * entry + a `scopeForPath` clause in the dock plus a `/api/search` leg, not a
 * new button per page.
 */
export function ScopedSearchButton({
  label = "Search",
  className,
}: {
  /** Accessible label / tooltip — e.g. "Search views". */
  label?: string;
  className?: string;
}) {
  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      aria-label={label}
      title={label}
      className={className}
      onClick={() => window.dispatchEvent(new CustomEvent("open-search"))}
    >
      <Icon name="search" />
    </Button>
  );
}
